// extracted by mini-css-extract-plugin
export var adjacentSlide = "_lo-9";
export var arrowButtonContainer = "_lo-5";
export var arrowButtonIcon = "_lo-6";
export var carouselArrowButton = "_lo-2";
export var carouselElementContainer = "_lo-1";
export var currentSlide = "_lo-8";
export var left = "_lo-3";
export var otherSlide = "_lo-a";
export var productCarouselContainer = "_lo-0";
export var right = "_lo-4";
export var sliderOverflow = "_lo-7";